import { TYPE_LABELS } from './typography.js';
import COLORS from './colors.js';

// export type PrimaryVariants = 'primary' | 'secondary' | 'tertiary';
// export type SecondaryVariants = 'primary' | 'secondary';
// export type VariantTypes = PrimaryVariants | SecondaryVariants;

// export type PrimaryColors = 'purps' | 'candy' | 'slate';
// export type SecondaryColors = 'green' | 'red' | 'white';
// export type ColorTypes = PrimaryColors | SecondaryColors;

// export type ButtonSizes = 'large' | 'medium' | 'small';

// export type IconPositionType = 'front' | 'back';

// export type ThemeDetailsType<
// 	Color extends PrimaryColors | SecondaryColors,
// 	Variant extends PrimaryVariants | SecondaryVariants,
// > = Record<Color, Record<Variant, ThemeDetailType>>;

// export type ThemeDetailType = {
// 	fontColor: string;
// 	backgroundColor?: string;
// 	activeBackgroundColor?: string;
// 	disabledBackgroundColor?: string;
// 	disabledFontColor?: string;
// 	borderColor?: string;
// 	disabledBorderColor?: string;
// };

// export type ButtonProps = {
// 	size: ButtonSizes;
// 	text?: string;
// 	icon?: React.ReactNode;
// 	iconPosition?: IconPositionType;
// 	className?: string;
// 	onClick?: null | ((e?: any) => void);
// 	width?: string;
// 	height?: string;
// 	isLoading?: boolean;
// 	loadingText?: string;
// 	isDisabled?: boolean;
// } & (
// 	| { variant: PrimaryVariants; color: PrimaryColors }
// 	| { variant: SecondaryVariants; color: SecondaryColors }
// );

// export type StyledButtonProps = {
// 	$size: ButtonSizes;
// 	$variant: VariantTypes;
// 	$color: ColorTypes;
// 	$width: string;
// 	$height: string;
// 	$isLoading: boolean;
// 	$iconPosition: IconPositionType;
// };

// : Record<ButtonSizes,{ fontLabel: string; padding: string; flexGap: string; borderRadius: string;}> TODO: Fix me when typesafe
export const SizeDetails = {
	large: {
		fontLabel: TYPE_LABELS.BUTTON_BIG,
		padding: '11px 20px 13px',
		flexGap: '8px',
		borderRadius: '8px',
		height: '48px',
	},
	medium: {
		fontLabel: TYPE_LABELS.BUTTON_MEDIUM,
		padding: '11px 16px 13px',
		flexGap: '8px',
		borderRadius: '8px',
		height: '44px',
	},
	small: {
		fontLabel: TYPE_LABELS.BUTTON_SMALL,
		padding: '8px 12px',
		flexGap: '4px',
		borderRadius: '4px',
		height: '32px',
	},
};

// : ThemeDetailsType<PrimaryColors, PrimaryVariants> & ThemeDetailsType<SecondaryColors, SecondaryVariants> TODO: Fix me when typesafe
export const ThemeDetails = {
	purps: {
		primary: {
			fontColor: COLORS.BRAND_COLORS.WHITE,
			backgroundColor: COLORS.BRAND_COLORS.PURPS,
			activeBackgroundColor: COLORS.TEXT.PURPS_3,
			disabledBackgroundColor: COLORS.GRAY.G5,
		},
		secondary: {
			fontColor: COLORS.TEXT.PURPS_3,
			disabledFontColor: COLORS.GRAY.G4A,
			backgroundColor: COLORS.BRAND_COLORS.WHITE,
			activeBackgroundColor: COLORS.PURPS_LEVEL[10],
			disabledBackgroundColor: COLORS.BRAND_COLORS.WHITE,
			borderColor: COLORS.BRAND_COLORS.PURPS,
			disabledBorderColor: COLORS.GRAY.G4A,
		},
		tertiary: {
			fontColor: COLORS.TEXT.PURPS_3,
			disabledFontColor: COLORS.BRAND_COLORS.WHITE,
			backgroundColor: COLORS.PURPS_LEVEL[10],
			activeBackgroundColor: COLORS.PURPS_LEVEL[20],
			disabledBackgroundColor: COLORS.GRAY.G5,
		},
	},
	candy: {
		primary: {
			fontColor: COLORS.BRAND_COLORS.WHITE,
			backgroundColor: COLORS.BRAND_COLORS.HEADOUT_CANDY,
			activeBackgroundColor: COLORS.HEADOUT_CANDY.TERTIARY,
			disabledBackgroundColor: COLORS.GRAY.G5,
		},
		secondary: {
			fontColor: COLORS.BRAND_COLORS.HEADOUT_CANDY,
			disabledFontColor: COLORS.GRAY.G4A,
			backgroundColor: COLORS.BRAND_COLORS.WHITE,
			activeBackgroundColor: COLORS.HEADOUT_CANDY.LIGHT_TONE_3,
			disabledBackgroundColor: COLORS.BRAND_COLORS.WHITE,
			borderColor: COLORS.BRAND_COLORS.HEADOUT_CANDY,
			disabledBorderColor: COLORS.GRAY.G4A,
		},
		tertiary: {
			fontColor: COLORS.BRAND_COLORS.HEADOUT_CANDY,
			disabledFontColor: COLORS.BRAND_COLORS.WHITE,
			backgroundColor: COLORS.BRAND_COLORS.HEADOUT_CANDY,
			activeBackgroundColor: COLORS.HEADOUT_CANDY.TERTIARY,
			disabledBackgroundColor: COLORS.GRAY.G5,
		},
	},
	slate: {
		primary: {
			fontColor: COLORS.BRAND_COLORS.WHITE,
			backgroundColor: COLORS.BRAND_COLORS.SLATE_BLACK,
			activeBackgroundColor: COLORS.GRAY.G3,
			disabledBackgroundColor: COLORS.GRAY.G5,
		},
		secondary: {
			fontColor: COLORS.GRAY.G2,
			disabledFontColor: COLORS.GRAY.G4A,
			backgroundColor: COLORS.BRAND_COLORS.WHITE,
			activeBackgroundColor: COLORS.GRAY.G6,
			disabledBackgroundColor: COLORS.BRAND_COLORS.WHITE,
			borderColor: COLORS.GRAY.G2,
			disabledBorderColor: COLORS.GRAY.G4A,
		},
		tertiary: {
			fontColor: COLORS.GRAY.G2,
			disabledFontColor: COLORS.BRAND_COLORS.WHITE,
			backgroundColor: COLORS.GRAY.G7,
			activeBackgroundColor: COLORS.GRAY.G5,
			disabledBackgroundColor: COLORS.GRAY.G5,
		},
	},
	green: {
		primary: {
			fontColor: COLORS.BRAND_COLORS.WHITE,
			backgroundColor: COLORS.BUTTON.OKAY_GREEN,
			activeBackgroundColor: COLORS.TEXT.OKAY_GREEN_3,
			disabledBackgroundColor: COLORS.GRAY.G5,
		},
		secondary: {
			fontColor: COLORS.TEXT.OKAY_GREEN_3,
			disabledFontColor: COLORS.GRAY.G4A,
			backgroundColor: COLORS.BRAND_COLORS.WHITE,
			activeBackgroundColor: COLORS.OKAY_GREEN.LIGHT_TONE_3,
			disabledBackgroundColor: COLORS.BRAND_COLORS.WHITE,
			borderColor: COLORS.BUTTON.OKAY_GREEN,
			disabledBorderColor: COLORS.GRAY.G4A,
		},
	},
	red: {
		primary: {
			fontColor: COLORS.BRAND_COLORS.WHITE,
			backgroundColor: COLORS.PRIMARY.WARNING_RED,
			activeBackgroundColor: COLORS.WARNING_RED.TERTIARY,
			disabledBackgroundColor: COLORS.GRAY.G5,
		},
		secondary: {
			fontColor: COLORS.TEXT.WARNING_RED_1,
			disabledFontColor: COLORS.GRAY.G4A,
			backgroundColor: COLORS.BRAND_COLORS.WHITE,
			activeBackgroundColor: COLORS.WARNING_RED.EXTRA,
			disabledBackgroundColor: COLORS.BRAND_COLORS.WHITE,
			borderColor: COLORS.PRIMARY.WARNING_RED,
			disabledBorderColor: COLORS.GRAY.G4A,
		},
	},
	white: {
		primary: {
			fontColor: COLORS.GRAY.G2,
			backgroundColor: COLORS.BRAND_COLORS.WHITE,
			activeBackgroundColor: COLORS.GRAY.G4A,
			disabledBackgroundColor: COLORS.GRAY.G3,
		},
		secondary: {
			fontColor: COLORS.BRAND_COLORS.WHITE,
			activeBackgroundColor: COLORS.BRAND_COLORS.SLATE_BLACK,
			borderColor: COLORS.BRAND_COLORS.WHITE,
			disabledBorderColor: COLORS.GRAY.G2,
		},
	},
};
